// extracted by mini-css-extract-plugin
export default {"cardSwiped":"SwipeCardAccountView_cardSwiped__ozUAH"};